import React from 'react'; 
import PropTypes from 'prop-types';

import Address, { AddressValidation } from '../../Address';
import Address2, { Address2Validation } from '../../Address2';
import PostBox, { PostBoxValidation } from '../../PostBox';

import RadioSection from '../../../Sections/RadioSection';

export default class BillingAddress extends React.Component {
    render() {
        if (this.props.lookup) {
            const p = this.props;
            let billingMethodItem = null;
            switch (p.selectedBillingAddress) {
                case "2":
                    billingMethodItem = <PostBox name={p.name + "_poBox"} disabled={p.disabled}/>;
                    break;
                case "3":
                    billingMethodItem = <Address2 name={p.name + "_address"} disabled={p.disabled}/>;
                    break;
                default:
                    billingMethodItem = null;
            }
            return (
                <div>
                    <RadioSection name={p.name} {...p.lookup} inline disabled={p.disabled}/>
                    {billingMethodItem}
                </div>
            );
        }
        else
            return null;
    }
}

BillingAddress.propTypes = {
    name: PropTypes.string.isRequired,
    lookup: PropTypes.object,
    selectedBillingAddress: PropTypes.string,
    disabled:PropTypes.bool
};

export function BillingAddressValidation(name, selectedAddress) {
    switch (selectedAddress) {
        case "2":
            return [...PostBoxValidation(name + "_poBox")];
        case "3":
            return [...Address2Validation(name + "_address")];
        default:
            return [];
    }
}